// Utils
import cn from '@/utils/cn';
// Style
import React from 'react';
import styles from './ToggleField.module.css';

// Components
import InputWrapper from '../../atoms/InputWrapper/InputWrapper';

interface ToggleFieldProps {
  id: string;
  name: string;
  error?: string;
  checked?: boolean;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  className?: string;
  theme?: 'light' | 'dark' | 'neutral';
  children: React.ReactNode;
}

function ToggleField({
  id,
  name,
  error,
  className,
  theme = 'light',
  checked = false,
  onChange,
  children,
}: ToggleFieldProps) {
  return (
    <InputWrapper error={error}>
      <label htmlFor={id} className={cn([styles.toggle, styles[theme], className])}>
        <input
          id={id}
          name={name}
          type="checkbox"
          className={styles['toggle-input']}
          checked={checked}
          onChange={onChange}
        />
        <span className={styles['toggle-slider']} />
        <span className={styles['toggle-label']}>{children}</span>
      </label>
    </InputWrapper>
  );
}

export default ToggleField;
